module.exports = __webpack_public_path__ + "static/media/red_logo.b66eb483.svg";